'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'GET_FEIS_START':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ loading: true }));

    case 'GET_FEIS':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)(action.payload));

    case 'GET_MY_FEISEANNA':
      return action.payload.reduce(function (state, f) {
        return state.setIn([f.feis.id], (0, _immutable.fromJS)(f.feis));
      }, state);

    case 'GET_RELEASED_FEISEANNA_FOR_SCHOOL':
    case 'GET_REGISTRABLE_FEISEANNA_FOR_SCHOOL':
      return action.payload.reduce(function (state, f) {
        return state.setIn([f.id], (0, _immutable.fromJS)(f));
      }, state);

    case 'GET_EVENT_LEVELS':
      return state.setIn(['eventLevels', action.feis_id], (0, _immutable.fromJS)(action.payload));

    case 'GET_EVENT_TYPES':
      return state.setIn(['eventTypes', action.feis_id], (0, _immutable.fromJS)(action.payload));

    case 'SET_SELECTED_DASHBOARD_FEIS':
      return state.set('selectedFeis', action.feis_id);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/one/index.js
// module id = 698
// module chunks = 0